<template>
  <li>
    <b-button type="is-primary is-light" class="ml-2" size="is-small" @click="$emit('click')">
      <b-icon icon="plus-circle"></b-icon>
      <span>Add</span>
    </b-button>
  </li>
</template>
<script>
export default {
  name: 'TabsAdd'
}
</script>
